export enum Units {
    None = "None",
    Meters = "Meters",
    Kilometers = "Kilometers",
    Miles = "Miles",
    Feet = "Feet"
}